import React from "react";

/**
 * Expert Craftsmanship icon — a random-orbital palm sander (round pad on the
 * lower-left, motor housing + grip, AIRLOCK-style dust bag on the right, trailing
 * cord). The round sanding pad (`.bdrv2-ico-sander-pad`) does a tight orbital
 * wiggle and kicks up sanding dust (`.bdrv2-ico-dust`) on chip hover / touch —
 * see the trigger rules in ourDoorsV2.css. Outline only; uses currentColor.
 */
const ServiceSanderIcon = () => (
  <svg
    className="bdrv2-ico-sander"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {/* motor housing + palm grip */}
    <path d="M6 31 C4 23 9 18.5 17 18.5 C24 18.5 31 20 33 24 C34 26 33 31 27 31 Z" />
    {/* grip ridge on top */}
    <path d="M12 19.5 C13 16.5 18 15.5 22 17.5" />
    {/* cooling vents */}
    <path d="M19 23 H25" />
    <path d="M19 26 H25" />
    {/* speed dial */}
    <circle cx="28.5" cy="24.5" r="1.6" />

    {/* dust port neck + AIRLOCK bag */}
    <path d="M33 22 H36 V27 H33" />
    <path d="M36 21.5 L45 25 L43.5 31 L36 28 Z" />

    {/* power cord */}
    <path d="M30 19.5 C35 16 40 15 46 14" />

    {/* round orbital sanding pad (animates) */}
    <g className="bdrv2-ico-sander-pad">
      <ellipse cx="15" cy="34.5" rx="11" ry="3.2" />
      <path d="M4 34.5 V36.1 A11 3.2 0 0 0 26 36.1 V34.5" />
    </g>

    {/* sanding dust (animates) — sprays out the left and right of the pad */}
    <g className="bdrv2-ico-dust bdrv2-ico-dust-l" fill="currentColor" stroke="none">
      <circle cx="5" cy="33" r="1.9" />
      <circle cx="3" cy="35" r="2.1" />
      <circle cx="4.5" cy="37" r="1.8" />
    </g>
    <g className="bdrv2-ico-dust bdrv2-ico-dust-r" fill="currentColor" stroke="none">
      <circle cx="25" cy="33" r="1.9" />
      <circle cx="27" cy="35" r="2.1" />
      <circle cx="25.5" cy="37" r="1.8" />
    </g>
  </svg>
);

export default ServiceSanderIcon;
